import toString_default from "./toString.js";
import _castSlice_default from "./_castSlice.js";
import _hasUnicode_default from "./_hasUnicode.js";
import _stringToArray_default from "./_stringToArray.js";

//#region ../../node_modules/lodash-es/_createCaseFirst.js
/**
* Creates a function like `_.lowerFirst`.
*
* @private
* @param {string} methodName The name of the `String` case method to use.
* @returns {Function} Returns the new case function.
*/
function createCaseFirst(methodName) {
	return function(string) {
		string = toString_default(string);
		var strSymbols = _hasUnicode_default(string) ? _stringToArray_default(string) : void 0;
		var chr = strSymbols ? strSymbols[0] : string.charAt(0);
		var trailing = strSymbols ? _castSlice_default(strSymbols, 1).join("") : string.slice(1);
		return chr[methodName]() + trailing;
	};
}
var _createCaseFirst_default = createCaseFirst;

//#endregion
export { _createCaseFirst_default as default };
//# sourceMappingURL=_createCaseFirst.js.map